class BlogFilterSort {
  constructor(containerId, sortSelectId) {
    this.container = document.querySelector(containerId);
    this.sortSelect = document.querySelector(sortSelectId);

    if (!this.container || !this.sortSelect) return;

    this.articles = Array.from(this.container.children);
    this.init();
  }

  init() {
    this.sortSelect.addEventListener('change', () => this.sortArticles());
    this.sortArticles();
  }

  sortArticles() {
    const sortVal = this.sortSelect.value;
    const sorted = this.articles.slice().sort((a, b) => {
      if (sortVal === 'title-asc') return a.dataset.title.localeCompare(b.dataset.title);
      if (sortVal === 'title-desc') return b.dataset.title.localeCompare(a.dataset.title);
      if (sortVal === 'published-asc') return new Date(a.dataset.date) - new Date(b.dataset.date);
      if (sortVal === 'published-desc') return new Date(b.dataset.date) - new Date(a.dataset.date);
      return 0;
    });

    this.container.innerHTML = '';
    sorted.forEach(article => this.container.appendChild(article));
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new BlogFilterSort('[data-blogs-container="BlogArticlesContainer"]', '[data-sort="blogs"]');
});